import React from "react";
import SbEditable from "storyblok-react";
import classnames from "classnames";
import { render, NODE_PARAGRAPH } from "storyblok-rich-text-react-renderer";
import styles from "./list.module.scss";
import { ListItemStoryblok, ListStoryblok } from "@/types/component-types-sb";

interface ListProps {
  blok: ListStoryblok;
  className?: string;
}

const List = (props: ListProps) => {
  const {
    blok: { items },
    className,
  } = props;
  const classes = classnames("list", styles.list, className);

  return (
    // @ts-expect-error
    <SbEditable content={props.blok}>
      <div className={classes}>
        {items &&
          items.map((item) => (
            <ListItem key={item._uid} content={item?.content} />
          ))}
      </div>
    </SbEditable>
  );
};

const ListItem = ({ content }: { content: ListItemStoryblok["content"] }) => {
  const contentRenderer = (children: React.ReactNode) => (
    <p className={styles.listItemContent}>{children}</p>
  );

  return (
    <div className={classnames("list-item", styles.listItem)}>
      {render(content, {
        nodeResolvers: {
          [NODE_PARAGRAPH]: contentRenderer,
        },
      })}
    </div>
  );
};

export default List;
